import React, { useContext } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import BackToStreamButton from '../../../Duperbrowse/BackToStreamButton';
import Details from '../../../DeviationViews/Details';
import Sidebar from '../../../Sidebar';
import ActionBar from '../../../ActionBar';
import ArtStage from '../../../ArtStage';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { isExtendedDeviationFullyLoaded } from '../../redux/helpers';
import Comments from '../Comments';
import CentralColumn from '../CentralColumn';
import s from './SimplePage.scss';

export interface Props {
  deviation: PapiDeviation;
  withoutSidebar?: boolean;
}

export const SimplePage: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  withoutSidebar,
}) => {
  const withSidebar = !withoutSidebar;
  const isMobile = useContext(MobileContext);
  const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
  const { needsSubscription } = useSubscriptionTier(deviation);

  return (
    <div
      className={classnames(
        s['root'],
        withSidebar && !isMobile && s['sidebar']
      )}
    >
      <div className={classnames(s['left-column'], s['stage'])}>
        <ArtStage deviation={deviation} />
        <BackToStreamButton />
        <ActionBar deviation={deviation} />

        <CentralColumn>
          <Details deviation={deviation} />
        </CentralColumn>
      </div>
      {withSidebar && !isMobile && (
        <Sidebar deviation={deviation} className={s['right-column']} />
      )}

      <div className={classnames(s['left-column'], s['meta'])}>
        <CentralColumn supportSidebar={withSidebar}>
          {!needsSubscription && isExtendedLoaded && (
            <Comments deviation={deviation} className={s['comments']} />
          )}
          {!needsSubscription && !isExtendedLoaded && (
            <LoadingIndicator className={s['lloader']} view="llama" />
          )}
        </CentralColumn>
      </div>
      {withSidebar && isMobile && (
        <Sidebar deviation={deviation} className={s['right-column']} />
      )}
      {withSidebar && <div className={s['clear']} />}
    </div>
  );
};
SimplePage.displayName = 'SimplePage';

export default SimplePage;
